import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function useTileControls() {
  const compositorTiles = useSelector((state) => state.call.compositorTiles);
  const ccModerationParticipants = useSelector(
    (state) => state.ccModeration?.ccModerationParticipants
  );
  

  const triggerCustomEvent = (eventName, data) => {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  };

  useEffect(() => {
    compositorTiles.forEach(({ element, isApplication, participantId }) => {
      if (isApplication) {
        return;
      }
      const tileControls = element.querySelector(".video-tile-controls");
      if (tileControls) {
        const participant = ccModerationParticipants.find(
          (participantData) =>
            participantData.particpantId === getScipId(participantId)
        );
        const ccModerationControl = tileControls.querySelector(
          ".tile-control.cc-moderation"
        );
        if (participant && !participant.isEnable) {
          if (ccModerationControl) {
            ccModerationControl.remove();
          }
          return;
        }
        if (
          participant &&
          (participant.currentValue === "on" ||
            participant.currentValue === "off")
        ) {
          let control = ccModerationControl;
          if (!control) {
            control = document.createElement("div");
            control.className =
              participant.currentValue === "on"
                ? "tile-control cc-moderation active"
                : "tile-control cc-moderation";
            tileControls.insertBefore(
              control,
              tileControls.firstElementChild.nextElementSibling
            );
          } else {
            if (participant.currentValue === "on") {
              control.classList.add("active");
            } else {
              control.classList.remove("active");
            }
          }

          control.onclick = () => {
            if (participant?.currentValue === "off") {
              control.classList.add("active");
            } else {
              control.classList.remove("active");
            }
            triggerCustomEvent("ccModerationClicked",{detail:participant});
          };
        } else if (ccModerationControl) {
          ccModerationControl.remove();
        }
      }
    });
  }, [compositorTiles, ccModerationParticipants]);

  const getScipId = (id) =>
    id?.substring?.(id.indexOf(":") + 1, id.indexOf(";"));
}
